import { propPanel as parentPropPanel } from '../text/propPanel';
import text from "../text";
export const propPanel = {
    ...text.propPanel,
    widgets: { ...parentPropPanel.widgets },
    schema: (propPanelProps) => {
        if (typeof parentPropPanel.schema !== 'function') {
            throw Error('Oops, is text schema no longer a function?');
        }
        return {
            ...parentPropPanel.schema(propPanelProps),
            '-------': { type: 'void', widget: 'Divider' },
            section: {
                title: propPanelProps.i18n('schemas.section'),
                type: 'string',
                widget: 'Input',
                span: 24,
                required: true,
            },
            appRender: {
                type: 'object',
                properties: {
                    label: {
                        title: propPanelProps.i18n('schemas.label'),
                        type: 'string',
                        widget: 'Input',
                        span: 24,
                        required: true,
                    },
                    options: {
                        title: 'Option',
                        type: 'array',
                        widget: 'OptionCounterWidget',
                        span: 24,
                        required: true,
                    },
                }
            }
        };
    },
    defaultSchema: {
        ...text.propPanel.defaultSchema,
        type: 'Dropdown',
        section: "",
        appRender: { label: "", options: [
                { id: 1, label: "Option 1", selected: true },
                { id: 2, label: "Option 2", selected: false },
                { id: 3, label: "Option 3", selected: false },
            ]
        },
        value: { label: "", options: [
                { id: 1, label: "Option 1", selected: true },
                { id: 2, label: "Option 2", selected: false },
                { id: 3, label: "Option 3", selected: false },
            ]
        },
    },
};
//# sourceMappingURL=propPanel.js.map